
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";

interface BenefitsBadgesProps {
  benefits: string[];
}

const BenefitsBadges = ({ benefits }: BenefitsBadgesProps) => {
  return (
    <div className="flex flex-wrap justify-center gap-4 mb-8">
      {benefits.map((benefit, index) => (
        <motion.div
          key={benefit}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 1 + index * 0.1 }}
          className="flex items-center gap-2 bg-card/50 backdrop-blur-sm px-4 py-2 rounded-full border border-border"
        >
          <CheckCircle className="h-4 w-4 text-foreground" />
          <span className="text-sm font-medium">{benefit}</span>
        </motion.div>
      ))}
    </div>
  );
};

export default BenefitsBadges;
